'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = Location;

var _querystringify = require('querystringify');

var _querystringify2 = _interopRequireDefault(_querystringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var regex = /^(?:(https?:)\/\/)?([^:/]*)(?::([^/]*))?([^?#]*)(\?[^#]+)?(#.+)?/;

function Location(loc) {
  var port = void 0;
  var hash = void 0;
  var query = void 0;
  var search = void 0;
  var pathname = void 0;
  var hostname = void 0;
  var protocol = void 0;

  if (typeof loc === 'string') {
    var _loc$match$slice = loc.match(regex).slice(1);

    var _loc$match$slice2 = _slicedToArray(_loc$match$slice, 6);

    protocol = _loc$match$slice2[0];
    hostname = _loc$match$slice2[1];
    port = _loc$match$slice2[2];
    pathname = _loc$match$slice2[3];
    search = _loc$match$slice2[4];
    hash = _loc$match$slice2[5];
  } else {
    var _ref = loc || {};

    protocol = _ref.protocol;
    hostname = _ref.hostname;
    protocol = _ref.protocol;
    pathname = _ref.pathname;
    search = _ref.search;
    query = _ref.query;
    hash = _ref.hash;
    port = _ref.port;
  }

  port = port || '';
  hash = hash || '';
  protocol = protocol || '';
  hostname = hostname || '';
  pathname = pathname || '/';
  search = search || (query && Object.keys(query).length ? _querystringify2.default.stringify(query, true) : '');
  query = query || (search ? _querystringify2.default.parse(search) : {});

  Object.assign(this, {
    host: port ? hostname + ':' + port : hostname,
    port: port,
    hash: hash,
    search: search,
    hostname: hostname,
    pathname: pathname,
    protocol: protocol,
    query: query,
    href: [protocol ? protocol + '//' : null, hostname, port ? ':' + port : null, pathname, search, hash].filter(function (v) {
      return v;
    }).join('')
  });
}